var React = require('react');

function IconMood (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#002771","d":"M19.43,39.15c-8.63,0-15.65-7.02-15.65-15.65c0-8.629,7.021-15.65,15.65-15.65s15.651,7.021,15.651,15.65\tC35.081,32.131,28.06,39.15,19.43,39.15 M19.43,10.112c-7.382,0-13.387,6.007-13.387,13.388c0,7.383,6.005,13.389,13.387,13.389\tS32.817,30.883,32.817,23.5C32.817,16.119,26.812,10.112,19.43,10.112 M27.57,39.15c-8.631,0-15.65-7.02-15.65-15.65\tc0-8.629,7.02-15.65,15.65-15.65c8.63,0,15.65,7.021,15.65,15.65C43.221,32.131,36.2,39.15,27.57,39.15 M27.57,10.112\tc-7.383,0-13.388,6.007-13.388,13.388c0,7.383,6.005,13.389,13.388,13.389c7.382,0,13.387-6.006,13.387-13.389\tC40.957,16.119,34.952,10.112,27.57,10.112"}));
}

IconMood.defaultProps = {"id":"Capa_1","width":"47","height":"47","x":"0","y":"0","enableBackground":"new 0 0 47 47","version":"1.1","viewBox":"0 0 47 47","xmlSpace":"preserve"};

module.exports = IconMood;

IconMood.default = IconMood;
